import { observable } from "mobx";
import { Type } from "class-transformer";
import OutgoingPayGatePaymentStatus from "./outgoingPayGatePaymentStatus";
import PayGateSenderBankAccountResponse from "./payGateSenderBankAccountResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OutgoingPayGateTransactionDetailResponse {
  @observable
  merchantId?: string;

  @observable
  terminalId?: string;

  @observable
  @Type(() => Date)
  authorizedAt?: Date;

  @observable
  @Type(() => Date)
  exportedDate?: Date;

  @observable
  variableSymbol?: number;

  @observable
  invoiceNumber?: string;

  @observable
  paidAmount!: number;

  @observable
  authCode?: string;

  @observable
  cardNumber?: string;

  @observable
  arn?: string;

  @observable
  @Type(() => PayGateSenderBankAccountResponse)
  senderBankAccount?: PayGateSenderBankAccountResponse;

  @observable
  status!: OutgoingPayGatePaymentStatus;
}
